import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-password-expired',
    templateUrl: './password-expired.component.html',
    styleUrls: ['./password-expired.component.scss'],
    standalone: false
})
export class PasswordExpiredComponent implements OnInit {

  year: number;
  constructor() { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

}
